
import { React, useState} from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../main-page.css'
import Button from 'react-bootstrap/Button';
import { Row, Col, Offcanvas } from 'react-bootstrap';
import { FaLongArrowAltRight } from "react-icons/fa";
import NavDropdown from 'react-bootstrap/NavDropdown';
import { CgMenuGridO } from "react-icons/cg";
import { RiGalleryLine } from "react-icons/ri";
import { FaChartArea } from "react-icons/fa";
import { GrStatusUnknown } from "react-icons/gr";
import Carousel from 'react-bootstrap/Carousel';
import NewsTicker from "./newsticker";
import { TiSocialFacebook } from "react-icons/ti";
import { FaTwitter } from "react-icons/fa";
import { FaGoogle } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";



function MainPage(){
  const [show, setShow] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleMouseEnter = (dropdown) => {
    setOpenDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    setOpenDropdown(null);

  };
  const [isPaused, setIsPaused] = useState(false);

  const handleMouseEnter1 = () => {
    setIsPaused(true);
  };

  const handleMouseLeave1 = () => {
    setIsPaused(false);
  };
  const newsItems = [
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
    "A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act. APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and technically, for construction of permanent (pucca) houses.",
  ];

  window.addEventListener('scroll', function() {
    var scrollPosition = window.scrollY; // Get vertical scroll position
    var textElement = document.getElementById('scrollingText');
    // Adjust horizontal scroll based on vertical scroll
    textElement.style.transform = 'translateX(' + (-scrollPosition * 0.5) + 'px)';
  });
  return (
    <>
      <Navbar expand="lg" className='main-navbar fixed-top' style={{boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px'}}>
        <Container fluid className='p-0'>
          <Navbar.Brand href="#home" className='d-flex align-items-center'>
            <a class="navbar-brand  d-flex align-items-center ms-2 ms-md-4" href="#">
            <img src="../images/apslogo.webp" alt="aps" className="img-fluid" />
            <div className="brand-text ms-2 text-left">
              <p className="brand-title">AndhraPradesh State<br></br><span>Housing</span> Corporation Limited</p>
            </div>
          <img src="../images/aplogo.webp" alt="Logo" className="img-fluid" />
          </a>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav"  className="border-0"/>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link className='active' href="/">Home</Nav.Link>
              <Nav.Link className='' href="/about">About</Nav.Link>
              <Nav.Link className='' href="/DashBoard">Dashboard</Nav.Link>
              <Nav.Link className='' href="/organogram">Organogram</Nav.Link>
              {/* <NavDropdown title="RTI" id="basic-nav-dropdown" show={openDropdown === 'committees'} onMouseEnter={() => handleMouseEnter('committees')} onMouseLeave={handleMouseLeave} className="">
                <NavDropdown.Item href="#action/3.1">Vigilance</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2">Women</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="GOs" id="basic-nav-dropdown" show={openDropdown === 'guest'} onMouseEnter={() => handleMouseEnter('guest')} onMouseLeave={handleMouseLeave} className="">
                <NavDropdown.Item href="#action/3.1">Vigilance</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2">Women</NavDropdown.Item>
              </NavDropdown> */}
              <Nav.Link className='' href="/donation">Donation</Nav.Link>
              <Nav.Link className='' href="/contact">Contact Us</Nav.Link>
            </Nav>
                <Button onClick={handleShow} className="menu-btn"><CgMenuGridO style={{ fontSize: '35px' }} />
                </Button>
                <Offcanvas show={show} onHide={handleClose} placement="end" className='main-off'>
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title></Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Nav defaultActiveKey="/home" className="side-nav">
                      <Nav.Link href="/home">Gallery</Nav.Link>
                      <Nav.Link href="/organogram"  eventKey="link-1">Organogram</Nav.Link>
                      <Nav.Link eventKey="link-2">Whos is who</Nav.Link>
                      <Nav.Link href="/contact" eventKey="link-2">Contact US</Nav.Link>
                    </Nav>
                  </Offcanvas.Body>
                </Offcanvas>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Container fluid className="banner-part-house">
      <Row>
        <Col xs={12} sm={12} lg={6} md={12} xl={6} xxl={6} className="house-banner-left px-0">
      <div className="banner-content">
      <h4>Government of Andhra<br />Pradesh <span>full fill the dream </span> <br />of houseless people.</h4>
          <p>
            One of the flagship programs managed by the department is the
            “Mana illu Mana gouravam” (Housing for All) scheme, which seeks to provide
            free or subsidized housing to the underprivileged. This scheme is part
            of a broader vision of the state government to ensure that every citizen
            has access to a proper home, promoting inclusivity and reducing
            homelessness.
          </p>
          <Button className="login-btn mt-3"><a href="https://aphousing.apcfss.in/login">Login</a></Button>
      </div>
      <div className="latest text-white">
            <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="latest-col1">
              <div className="notification-head">
              <h5>Latest<br></br>Updates</h5>
              </div>
              </Col>
              <Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className="latest-col2">
                  <NewsTicker news={newsItems} interval={3000}/>
                </Col>
            </Row>
          </div>
        </Col>
        <Col xs={12} sm={12} lg={6} md={12} xl={6} xxl={6} className="slide-col">
        {/* <img src="../images/banner-img1.webp" className="img-fluid banner-img"/> */}
        <Row className="main-persons-images">
        <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12}></Col>
        <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
        <Row className="py-4">  
        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
        <img src=" images/cm-image.webp" alt="" className="img-fluid"></img>
        {/* <div className="cm-text">
        <h5>Sri. Nara Chandrababu Naidu</h5>
        <p className="text-center">Hon’ble Chief Minister <br />Government of Andhra Pradesh</p>
        </div> */}
        </Col>
        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
        <img src=" images/minister-image.webp" alt="" className="img-fluid "></img>
        {/* <div className="cm-text">
        <h5>Sri. Kolusu Parthasarathy</h5>
        <p className="text-center">Hon’ble Minister for Housing and I&PR<br />Government of Andhra Pradesh</p>
        </div> */}
        </Col>
        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
        <img src=" images/chairman.webp" alt="" className="img-fluid "></img>
        {/* <div className="cm-text">
        <h5>Sri. Kolusu Parthasarathy</h5>
        <p className="text-center">Hon’ble Minister for Housing and I&PR<br />Government of Andhra Pradesh</p>
        </div> */}
        </Col>
        </Row>
        </Col>
        <Col xxl={2} xl={2} lg={2} md={2} sm={12} xs={12}></Col>
        </Row>
        <Row>
        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="banner-carousel px-0">
        <Carousel slide={false}>
      <Carousel.Item>
      <img src="../images/slid-img-1.webp" className="img-fluid"/>  
      </Carousel.Item>
      <Carousel.Item>
      <img src="../images/slid-img-2.webp" className="img-fluid"/>
      </Carousel.Item>
      <Carousel.Item>
      <img src="../images/slid-img-3.webp" className="img-fluid"/>
      </Carousel.Item>
      <Carousel.Item>
      <img src="../images/slid-img-4.webp" className="img-fluid"/>  
      </Carousel.Item>
      <Carousel.Item>
      <img src="../images/slid-img-5.webp" className="img-fluid"/>
      </Carousel.Item>
      <Carousel.Item>
      <img src="../images/slid-img-6.webp" className="img-fluid"/>
      </Carousel.Item>
    </Carousel>
        </Col>
        </Row>
        </Col>
     </Row>   
    </Container>
{/*---------------Welcome----------------------*/}
<section className="cm-min-images position-relative">
<img src='../images/blueprint.webp' className="img-fluid blueprint-shape"/>
<Container className="schemes-contain">
 <Row>
 <Col xs={12} sm={12} md={0} lg={2} xl={2} xxl={2} className="my-auto"></Col>
 <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className="my-auto schemes">
 <h2><span className="houseing-text">About</span> <br />APSHCL</h2>
 </Col>
 
    <Col xs={12} sm={12} lg={6} md={8} xl={6} xxl={6} className="Welcome-part mt-5 mt-lg-none">
    <p>
    A.P. State Housing Corporation Limited (APSHCL) was incorporated on 5th July 1979 under Companies Act.
     APSHCL aims to bring dignity to each and every BPL family by assisting them, both financially and
      technically, for construction of permanent (pucca) houses. Aphousing (often referred to as affordable housing)
       is a term used to describe housing that is deemed affordable to those with a median household income, particularly
        in reference to housing units that are subsidized or have costs controlled to remain within the financial reach 
        of lower-income residents. Affordable housing is crucial in urban planning and development as it addresses the needs 
        of economically vulnerable populations, including low-income 
    families, seniors, and individuals with disabilities.
    </p>
    <p className="d-none d-xl-block">
    Affordable housing initiatives also aim to promote social equity by reducing homelessness, overcrowding, and housing 
    instability. These programs are often linked with broader goals such as community development, access to education
     and healthcare, and improved quality of life for underserved populations. However, the availability of affordable
      housing is often a challenge, particularly in regions experiencing rapid urbanization, rising property values,
       and limited land for development.
    </p>
   
   <a href="/about"><button type="button"   class="btn viewbtn">View More</button></a> 
    </Col>
    </Row>
    </Container>
</section>
{/* ------------------------------------------ */}
{/* -----------Pradhana mantri Yojana--------- */}
<section id="padhan-mantri">
  <Container>
    <Row>
    <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className="pradhan-col">
    <div className="pradhan-mantri-logo">
     <img src="../images/pradhan.webp" className="img-fluid logo1"/>
     <div>
     <h5>Pradhan Mantri<br></br>Awas Yojana </h5>
     <p>(Gramin)-PMAY (G)</p>
     </div>
    </div>
    <div className="awasayojan-text">
    <p>In pursuance of Government’s vision of facilitating Housing for All, Ministry of Housing and Urban Affairs (MoHUA), Government of India is implementing Pradhan Mantri Awas Yojana- Urban (PMAY-U) – ‘Housing for All’ Mission since 25.06.2015. The original mission period was up to 31.03.2022 which has been extended till 31.12.2024 for completion of houses sanctioned up to 31.03.2022, without changing funding pattern and implementation methodology of the scheme. The validity of CLSS vertical was up to 31.03.2022. Under the Mission, Ministry has been providing Central assistance to States/ UTs for addressing the housing requirement of the slum dwellers and other people belonging to Economically Weaker Sections (EWS), Low Income Group (LIG) and Middle Income Group (MIG) categories in the urban areas through following four verticals:</p>
    <p><b>Beneficiary-led Individual House Construction or Enhancement (BLC):</b>Under this vertical, Central Assistance of ₹1.5 lakh is provided to individual eligible families belonging to EWS categories.</p>
    <p><b>Affordable Housing in Partnership with public or private sector (AHP):</b>Central Assistance of ₹1.5 lakh per EWS house is provided by Government of India in projects where at least 35% of the houses in the projects are for EWS category and a single project has at least 250 houses.</p>
    </div>
    <div className="container">
     <button class="know-more ms-auto"><a href="https://pmay-urban.gov.in" target="_blank"><span class="circle" aria-hidden="true"><span class="icon arrow"><img src="images/vector.webp" class="right-arrow" alt=""/></span></span><span class="button-text contrasttext">Know More</span></a></button>
     </div>
    </Col> 
    <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className="mt-5 mt-lg-0">
    <div className="pradhan-mantri-logo">
     <img src="../images/pradhan1.png" className="img-fluid logo2"/>
     <div className="mt-4 mt-md-0">
     <h5>Pradhan Mantri<br></br>Awas Yojana </h5>
     <p>(Urban)-PMAY (U)</p>
     </div>
    </div>
    <div className="awasayojan-text">
    <p>Public housing programme in the country started with the rehabilitation of refugees immediately after independence and since then, it has been a major focus area of the Government as an instrument of poverty alleviation. Rural housing programme,as an independent programme , started with Indira Awaas Yojana (IAY) in January 1996. Although IAY addressed the housing needs in the rural areas, certain gaps were identified during the concurrent evaluations and the performance Audit by Comptroller and Auditor General (CAG) of India in 2014. These gaps, i.e. nonassessment of housing The shortage, lack of transparency in selection of beneficiaries, low the quality of the house and lack of technical supervision, lack convergence, loans not availed by beneficiaries and weak the mechanism for monitoring was limiting the impact and outcomes of the programme.</p>
    <p>To address these gaps in the rural housing program and in view of Government’s commitment to providing “Housing for All’’ by the scheme 2024, the of has IAY has been re-structured into Pradhan Mantri Awaas Yojana –Gramin (PMAY-G) w.e.f. 1st April 2016.</p>
    <p>PMAY-G aims at providing a pucca house, with basic amenities, to all houseless householder and those households living in kutcha and dilapidated house, by 2024. The immediate the objective is to cover 1.00 crore household living in kutcha house/dilapidated house in three years from 2016-17 to 2018- 19.</p>
    </div>
    <div className="pradhan-mantri-text px-0 px-xl-3">
     <div className="container">
     <button class="know-more ms-auto"><a href="https://pmayg.nic.in/netiayHome/home.aspx" target="_blank"><span class="circle" aria-hidden="true"><span class="icon arrow"><img src="images/vector.webp" class="right-arrow" alt=""/></span></span><span class="button-text contrasttext">Know More</span></a></button>
     </div>
    </div>
    </Col>
    </Row>
  </Container>
</section>
{/* ----------------------------------------- */}
{/*---------------Schemes------------------*/}
    <section id="schemes-bg">
    <h1 class="fixed-text" id="scrollingText">AP HOUSING</h1>
     <Container className="schemes-contain">
      <div className="schemes-row">
      <Row>
       <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12} className="schemes-box">
       <div className="schemes-box-content1 text-center">
        <img src="../images/sanction.webp" className="img-fluid"/>
        <p>Houses sanctioned</p>
        <h5>1,84,565</h5>
       </div>
       </Col> 
       <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12} className="schemes-box">
       <div className="schemes-box-content2 text-center">
        <img src="../images/grounded.webp" className="img-fluid"/>
        <p>Houses Grounded</p>
        <h5>1,24,586</h5>
       </div></Col> 
       <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12} className="schemes-box">
       <div className="schemes-box-content3 text-center">
        <img src="../images/completed.webp" className="img-fluid"/>
        <p>Houses Completed</p>
        <h5>5,46,235</h5>
       </div></Col> 
      </Row>
      </div>
     </Container>
    </section>
{/* ---------------------------------------------- */}
{/* ------------urban-Rural------------------- */}
{/* <section className="schemes position-relative">
<Container className="schemes-contain">
<Row>
<Col xs={12} sm={12} lg={4} md={12} xl={4} xxl={4} className="my-auto">
<h2><span className="houseing-text"> Housing</span> <br />
Schemes</h2>
</Col>
<Col xs={12} sm={12} lg={4} md={12} xl={4} xxl={4} className="box px-2 px-xl-4 mt-5 mt-lg-0">  
<div className="urban"> 
  <div className="d-flex">
     <div className="circlepart1">
  <img src=" images/urban.webp" alt="" className="img-fluid"></img>
  </div>
<div className="my-auto">
  <h3>Urban</h3>
</div>
  </div>
  <p>In urban areas, APSHCL addresses the growing demand for affordable housing by 
    developing housing colonies and apartments for low-income groups. The organization 
    collaborates with local municipalities and urban development authorities to ensure 
    that housing projects meet the needs of urban dwellers, particularly slumUrban housing 
    projects also focus on integrating modern infrastructure like water supply, sewage systems, 
    and access to public services, contributing to the overall urban development</p>
<div className="d-flex justify-content-end">
<button type="button" class="btn viewbtn">View More</button>
</div>
</div>
</Col>
<Col xs={12} sm={12} lg={4} md={12} xl={4} xxl={4} className="box px-2 px-xl-4 mt-4 mt-lg-0">
<div className="rural"> 
  <div className="d-flex">
     <div className="circlepart2">
  <img src=" images/rural.webp" alt="" className="img-fluid"></img>
  </div>
<div className="my-auto">
  <h3>Rural</h3>
</div>
  </div>
  <p>The housing corporation also focuses on providing essential infrastructure such as roads, 
    drainage systems, and sanitation facilities in rural housing projects, contributing to a 
    more holistic development approach. By prioritizing rural development, APSHCL aims to reduce 
    migration to urban centers, thereby promoting sustainable growth in villages. The organization builds pucca houses that are resistant to weather extremes,
     thus improving the living conditions of families in rural communities.</p>
    <button type="button" class="btn viewbtn float-end mb-5">View More</button>
</div>
</Col>
</Row>
</Container>
<img src='../images/blueprint.webp' className="img-fluid blueprint-shape"/>
</section> */}
{/* ------------urban-Rural------------------- */}
{/* -----------------Gallery----------------- */}
<section id="gallery">
  <Container>
    <div className="gallery-head">
     <h4>Gallery</h4>
    </div>
  <Row>
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="p-0">
    <img src="../images/gallery1.webp" className="img-fluid w-100"/>
    </Col>
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="p-0">
    <img src="../images/gallery2.webp" className="img-fluid w-100"/>
    </Col>
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="p-0">
    <img src="../images/gallery3.webp" className="img-fluid w-100"/>
    </Col>
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="p-0">
    <img src="../images/gallery4.webp" className="img-fluid w-100"/>
    </Col>
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="p-0">
    <img src="../images/gallery5.webp" className="img-fluid w-100"/>
    </Col>
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="p-0">
    <img src="../images/gallery6.webp" className="img-fluid w-100"/>
    </Col>
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="p-0">
    <img src="../images/gallery7.webp" className="img-fluid w-100"/>
    </Col>
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="p-0">
    <img src="../images/gallery8.webp" className="img-fluid w-100"/>
    </Col>
  </Row>
  </Container>
</section>
{/* ----------------------------------------- */}
{/* ---------------Footer------------------- */}
<footer className="pt-5 position-relative footer-part">
<img src="../images/blue-bottom-img.webp" className="img-fluid blue-bottom-img"/>  
<Container className="footer-contain">
 <Row>
  <Col xs={12} sm={12} lg={3} md={6} xl={3} xxl={3} className="mb-4 mb-md-0">
  <div className="footer-content">
   <h5>Address</h5>
   <p className="adsress-text">AP State Housing Corporation<br></br>Plot No : 11 & 12 Behind BSNL,<br></br>Telephone Exchange Auto Nagar,<br></br>Vijayawada, Andhra Pradesh- 520007.</p> 
  </div>
  <ul className="social-media-icons">
  <li><a href="#"><TiSocialFacebook className="icony"/></a></li>
  <li><a href="#"><FaTwitter className="icony"/></a></li>
  <li><a href="#"><FaGoogle className="icony"/></a></li>
  <li><a href="#"><FaYoutube className="icony"/></a></li>
  <li><a href="#"><FaInstagram className="icony"/></a></li>
</ul>
  </Col>
  <Col xs={12} sm={12} lg={3} md={6} xl={3} xxl={3}>
  <div className="footer-content">
  <h5>Important <span>Links</span></h5>
  <ul>
  <li><a href="#">PMAY-GRAMIN</a></li>  
  <li><a href="#">PMAY-URBAN</a></li>  
  <li><a href="#">Beneficiary Search</a></li>  
  <li><a href="#">OFMS</a></li>  
  <li><a href="#">Tenders</a></li>  
  <li><a href="#">RTI - Andhra Pradesh</a></li>  
  <li><a href="#">RTI - Government of India</a></li>  
  </ul>
  </div>
  </Col>
  <Col xs={12} sm={12} lg={3} md={6} xl={3} xxl={3}>
  <div className="footer-content">
  <h5>Quick <span>Links</span></h5>
  <ul>
  <li><a href="#">Contact Us</a></li>  
  <li><a href="#">Gallery</a></li>  
  <li><a href="#">FAQ's</a></li>  
  <li><a href="#">News & Articles</a></li>  
  <li><a href="#">Signin / Login</a></li>  
  <li><a href="#">GO’s</a></li>  
  <li><a href="#">Circular's</a></li>  
  </ul>
  </div>
  </Col>
  <Col xs={12} sm={12} lg={3} md={6} xl={3} xxl={3}>
  <div className="footer-content">
  <h5>Get in <span>Touch</span></h5>
  <div className="phone d-flex">
  <img src="../images/phone.webp" className="phone-img"/>
  <div className="phone-text">
  <h6>Toll free Number</h6>
  <p>08663501300</p>
  </div> 
  </div>
  <div className="email d-flex">
  <img src="../images/email.webp" className="email-img"/>
  <div className="email-text">
  <h6>Email ID</h6>
  <p>housing.ap@gmail.com</p>
  </div> 
  </div>
  <div className="location d-flex">
  <img src="../images/location.webp" className="location-img"/>
  <div className="location-text">
  <h6>Location</h6>
  <p>Vijayawada</p>
  </div> 
  </div>
  </div>
  </Col>
  </Row>
  <hr className="mb-0"></hr>
  <Row className="pt-4 pb-3">
  <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className="py-2 py-md-0">
  <div className="brand-text-bottom">
    <p>All Rights Reserved © 2024, APSHCL</p>
  </div>
  </Col>
  <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className="py-2 py-md-0">
  <div className="brand-text-bottom brand-text-bottom2">
    <p>Visitors Count : <span>850278</span></p>
  </div>
  </Col>
  <Col xs={12} sm={12} lg={4} md={4} xl={4} xxl={4} className="py-2 py-md-0">
  <div className="brand-text-bottom brand-text-bottom3">
    <p>Design and Developed by</p>
    <a href="https://apcfss.in/" target="_blank"><img src="../images/apcfss.webp" className="brand-logo"/></a>
  </div>
  </Col>
 </Row> 
</Container>  
</footer>
</>

  )
}
export default MainPage;